/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  // {
  //   url: "/manage_monitoring",
  //   name: "Monitoring",
  //   slug: "manage_monitoring",
  //   icon: "MonitorIcon",
  // },
  {
    url: "/manage_dashboard",
    name: "Dashboard",
    slug: "manage_dashboard",
    icon: "MonitorIcon",
  },
  {
    url: "/manage_news",
    name: "จัดการข่าวสาร",
    slug: "manage_news",
    icon: "RssIcon",
  },
  {
    url: "/manage_home",
    name: "จัดการลูกบ้าน",
    slug: "manage_home",
    icon: "HomeIcon",
  },
  {
    url: "/manage_transactions",
    name: "ข้อมูลรถเข้า-ออก",
    slug: "manage_transactions",
    icon: "TruckIcon",
  },
  {
    url: "/manage_scan_report",
    name: "ข้อมูลการเดินตรวจ",
    slug: "manage_scan_report",
    icon: "GitPullRequestIcon",
  },
  {
    url: "/manage_car_overlap",
    name: "ข้อมูลการตรวจซ้อนคัน",
    slug: "manage_car_overlap",
    icon: "ShuffleIcon",
  },
  {
    url: "/manage_ticket_transactions",
    name: "ข้อมูลบัตรผ่าน",
    slug: "manage_ticket_transactions",
    icon: "CheckSquareIcon",
  },
  {
    url: "/manage_close_home",
    name: "ข้อมูลแจ้งปิดบ้าน",
    slug: "manage_close_home",
    icon: "ShieldIcon",
  },
  {
    url: "/manage_vip",
    name: "ข้อมูลแขกวีไอพี",
    slug: "manage_vip",
    icon: "UserCheckIcon",
  },
  {
    url: "/manage_request_help",
    name: "ข้อมูลเรียกใช้บริการ",
    slug: "manage_request_help",
    icon: "PhoneCallIcon",
  },
  {
    url: "/ksetting",
    name: "ตั้งค่าส่งรายงาน",
    slug: "setting_report",
    icon: "SettingsIcon",
  },
  // {
  //   url: "/home_user_dash",
  //   name: "แดชบอร์ด",
  //   slug: "home",
  //   icon: "HomeIcon",
  // },
  // {
  //   url: "/home_user_news",
  //   name: "ข่าวสาร",
  //   slug: "home_user_news",
  //   icon: "BellIcon",
  // },
  // {
  //   url: "/home_user_stamp",
  //   name: "ประทับตรา",
  //   slug: "home_user_stamp",
  //   icon: "UserCheckIcon",
  // },

  // {
  //   url: "/home_user_home_config",
  //   name: "เปิดปิดบ้าน",
  //   slug: "home_user_home_config",
  //   icon: "ShieldIcon",

  // },
  // {
  //   url: "/home_user_fix",
  //   name: "แจ้งซ่อม",
  //   slug: "home_user_fix",
  //   icon: "ToolIcon",
  // },
  // {
  //   url: "/home_user_fix",
  //   name: "สนทนา",
  //   slug: "home_user_fix",
  //   icon: "MessageCircleIcon",
  // }
];
